export function setMessage(action, msg) {
  return JSON.stringify({
    action: action,
    data: msg,
  });
}
